import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  startAuditAsync,
  checkAuditStatus,
  resetAudit,
} from "../store/slices/auditSlice";

export const useAuditRunner = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { status, auditId, progress, error, url, reportData } = useSelector(
    (state) => state.audit
  );

  // Poll for audit status
  useEffect(() => {
    let interval;

    if (status === "polling" && auditId) {
      interval = setInterval(() => {
        dispatch(checkAuditStatus(auditId));
      }, 2000); // Poll every 2 seconds
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [status, auditId, dispatch]);

  // Handle audit completion
  useEffect(() => {
    if (status === "completed" && reportData) {
      navigate("/report");
    }
  }, [status, reportData, navigate]);

  const runAudit = useCallback(
    async (targetUrl) => {
      dispatch(resetAudit());
      dispatch(startAuditAsync(targetUrl));
    },
    [dispatch]
  );

  const cancelAudit = useCallback(() => {
    dispatch(resetAudit());
  }, [dispatch]);

  return {
    runAudit,
    cancelAudit,
    status,
    progress,
    error,
    url,
    isRunning: status === "loading" || status === "polling",
  };
};
